/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */
import cx from 'classnames'
import React from 'react'
// import styles from './styles.module.css'

const Viewer = props => {
  const { className, frameRef, setHandler, sumerianUrl } = props
  return (
    <div className={cx('sumerianViewer', className)}>
      <iframe
        ref={frameRef}
        src={sumerianUrl}
        title="Sumerian Pedwinds Test"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        onLoad={setHandler}
        allowFullScreen={true}
        allow="vr; microphone; camera; geolocation; midi; encrypted-media; fullscreen; autoplay"
      />
    </div>
  )
}

export default Viewer
